import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, Spinner } from 'react-bootstrap';

const ETAReasonModal = ({ show, onHide, showProgress, onSubmit, initialValues = {}, setLoadingMetaData }) => {
  const [formData, setFormData] = useState({
    etaReason: '',
    newEta: ''
  });

  useEffect(() => {
    if (!show) return;
    setFormData({
      etaReason: initialValues.etaReason ?? '',
      newEta: initialValues.newEta ?? ''
    });
  }, [show, initialValues]);

  const handleSubmit = () => {
    const etaReason = formData.etaReason.trim() || null;
    if (!formData.newEta) return;
    setLoadingMetaData(prevState => ({ ...prevState, eta: true }));
    onSubmit({
      etaReason,
      newEta: formData.newEta
    });
  };

  const handleCancel = () => {
    setFormData({
      etaReason: '',
      newEta: ''
    });
    onHide();
  };

  const isFormValid = Boolean(formData.newEta);

  return (
    <Modal show={show} onHide={handleCancel} centered backdrop="static">
      <Modal.Header>
        <Modal.Title>
          <h6 className="mb-0">ETA Reason</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-auto">

        <Form.Group className="mb-3">
          <Form.Label>New ETA <span className="text-danger">*</span></Form.Label>
          <Form.Control
            type="date"
            value={formData.newEta}
            onChange={e => setFormData({ ...formData, newEta: e.target.value })}
            disabled={showProgress}
            placeholder="Select new ETA"
            />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>ETA Reason</Form.Label>
          <Form.Control
            as="textarea"
            value={formData.etaReason}
            onChange={e => setFormData({ ...formData, etaReason: e.target.value })}
            disabled={showProgress}
            placeholder="Enter ETA reason"
            rows={3}
            />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button size="sm" disabled={showProgress} className="ml-2 px-2" variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          size="sm"
          disabled={showProgress || !isFormValid}
          className="ml-2 px-2 d-inline-flex align-items-center justify-content-center"
          variant="primary"
          onClick={handleSubmit}
        >
          {showProgress && <Spinner size="sm" animation="border" className="mr-1" />}
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ETAReasonModal;
